type SpinnerProps = {
  size?: 'md' | 'lg';
  label?: string;
};

export function Spinner({ size = 'md', label = 'Загрузка' }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite">
      <span className={size === 'lg' ? 'spinner spinner--lg' : 'spinner'} aria-hidden="true" />
      <span className="visually-hidden">{label}</span>
    </span>
  );
}
